import * as React from "react";
import QrCode from "qrcode.react";
import { useCallback, useMemo, useState } from "react";
import { useClinicData } from "../../clinic/clinicHooks";
import { PatientPopup } from "./patientPopup";
import { CircularProgress, IconButton, styled } from "@mui/material";
//region [[ Styles ]]
const CodePopup = styled(PatientPopup)({
  "& .patient-popup-container": {
    height: "100vh",
    background: "transparent",
  },
  "& canvas": {
    width: "100%",
  },
  "& .close-button": {
    color: "white",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface QrCodeProps {
  value: string;
  loading?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
const PROD_DOMAIN = "diagnose";
const STAGE_DOMAIN = "staging";
const DEV_DOMAIN = "develop";
const BASE_URL = `https://${
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? PROD_DOMAIN
    : process.env.REACT_APP_ENVIRONMENT === "staging"
    ? STAGE_DOMAIN
    : DEV_DOMAIN
}.kahun.com`;

export const ClinicQrCode = ({ value, ...props }: QrCodeProps) => {
  const { clinic } = useClinicData();

  const [showFullScreen, setShowFullScreen] = useState(false);

  const urlToPatientCard = useMemo(() => {
    // ex: https://develop.kahun.com/clinic_manage/87eb8830-324e-4cd6-b756-018b502d17ae/patients/A5ESN
    return `${BASE_URL}/clinic_manage/${clinic}/patients/${value}`;
  }, [clinic, value]);

  const togglePopup = useCallback(() => {
    setShowFullScreen((preVal) => !preVal);
  }, [setShowFullScreen]);

  const renderQrButton = () => (
    <IconButton onClick={togglePopup}>
      <QrCode value={urlToPatientCard} size={256} />
    </IconButton>
  );
  if (props.loading) return <CircularProgress />;

  if (!showFullScreen) return renderQrButton();

  return (
    <CodePopup open={showFullScreen} onClose={togglePopup}>
      {renderQrButton()}
    </CodePopup>
  );
};
